module.exports = __webpack_public_path__ + "img/sidebar-bg.bc403019.jpg";